'use strict';
import {APP_ROOT_STATE} from '../../app/router';

/**
 * Force view-cache clear for blacklisted states when transitioning with mode == 'none'.
 *
 * Primarily in place to fix the bug where redux lists are not reset properly according to the view props due to caching.
 *
 * Secondarily, clears cached React and DOM elements to reduce memory leaks due to IonicHistory bugs.
 *
 * @param stateName
 * @param prevStateName
 * @return {boolean}
 */
export function clearOnNone(stateName, prevStateName) {
  if (!prevStateName) {
    return false;
  }

  const prevAppState = getAppState(prevStateName);
  const currAppState = getAppState(stateName);

  if (prevAppState === currAppState) {
    return false;

  } else if (isCacheBlacklistState(prevAppState)) {
    return true;

  }
}

function getAppState(name) {
  const tokens = name.substr(0, 3) === APP_ROOT_STATE ? name.split('.') : [];

  // second token is app child state against main menu
  return tokens.length > 1 ? `${APP_ROOT_STATE}.${tokens[1]}` : null;
}

/**
 * TODO(redux-nav): Add views needed to fix broken view caching
 * @param name
 * @return {boolean}
 */
function isCacheBlacklistState(name) {
  switch (name) {
    case 'app.projects':
    case 'app.assets':
      return true;

    default:
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/js/config/router/cleanup.js